"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgStrCompact = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextItem_1 = require("../../ContextItem");
const Input_1 = require("../../../../2-inline-block/Input");
const OptionalBadge_1 = require("./OptionalBadge");
const DefaultableToggle_1 = require("./DefaultableToggle");
const AutoValue_1 = require("./AutoValue");
const readStructured = (v) => {
    if (v && typeof v === 'object' && 'def' in v) {
        const s = v;
        return { def: !!s.def, value: String(s.value ?? '') };
    }
    return { def: false, value: typeof v === 'string' ? v : '' };
};
const ArgStrCompact = ({ param, value, onChange, onEnter, focus }) => {
    const [t] = (0, use_t_1.useT)();
    const label = param.display?.() ?? t(param.name ?? param.id ?? '');
    const defaultable = !!param.defaultable;
    const s = readStructured(value);
    const def = defaultable && s.def;
    const handleEnter = (event) => {
        onEnter?.(event);
        param.onSubmit?.();
    };
    const emit = (next) => {
        if (defaultable)
            onChange(next);
        else
            onChange(next.value);
    };
    const setText = (v) => emit({ def: false, value: v });
    const enterCustom = () => emit({ def: false, value: s.value });
    const revertToAuto = () => emit({ def: true, value: s.value });
    const customControl = (React.createElement("div", { style: { width: 140, margin: '-5px -8px -5px 0' } },
        React.createElement(Input_1.Input, { size: -3, type: "text", value: s.value, placeholder: param.placeholder, focus: focus, onChange: setText, onEnter: handleEnter })));
    const autoDisplay = (React.createElement(AutoValue_1.AutoValue, { onClick: enterCustom },
        React.createElement("span", { style: { fontSize: 13 } }, param.default || t('auto'))));
    const right = defaultable ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 4, margin: '-5px -4px -5px 0' } }, def ? (React.createElement(React.Fragment, null,
        React.createElement(DefaultableToggle_1.DefaultableToggle, { def: true, onClick: enterCustom }),
        autoDisplay)) : (React.createElement(React.Fragment, null,
        React.createElement(DefaultableToggle_1.DefaultableToggle, { def: false, onClick: revertToAuto }),
        customControl)))) : (customControl);
    return (React.createElement(ContextItem_1.ContextItem, { icon: param.icon?.(), control: true, inset: true, right: right },
        React.createElement("span", null,
            label,
            param.optional && React.createElement(OptionalBadge_1.OptionalBadge, null))));
};
exports.ArgStrCompact = ArgStrCompact;
